import { SvgIcon, Typography, makeStyles } from "components/mui-core";
import Tooltip from "components/Tooltip";
import { CampaignStatusView } from "model/campaigns/viewStatus";
import { LineitemStatus } from "model/lineitems";
import { LineitemViewStatus } from "model/lineitems/viewStatus";
import React from "react";
import {
  dangerColor,
  grayColor,
  infoColor,
  successColor,
  warningColor,
} from "vendor/material-dashboard-pro-react-v1/assets/jss/material-dashboard-pro-react";

const useStyles = makeStyles({ index: 1 })({
  status: {
    fontSize: 13,
    fontWeight: "lighter",
    textTransform: "capitalize",
    height: 20,

    //text
    [`&.${CampaignStatusView.Finished}, &.${LineitemStatus.Finished}`]: {
      color: infoColor[0],
    },
    [`&.${CampaignStatusView.Draft}, &.${LineitemViewStatus.Archived}`]: {
      color: grayColor[0],
    },
    [`&.${CampaignStatusView.Running}, &.${LineitemStatus.Running}`]: {
      color: successColor[0],
    },
    [`&.${CampaignStatusView.Paused}, &.${LineitemStatus.Paused}`]: {
      color: dangerColor[0],
    },
    [`&.${LineitemStatus.AutoPaused}`]: {
      color: warningColor[0],
    },

    //svg
    [`&.${CampaignStatusView.Finished} svg, &.${LineitemStatus.Finished} svg`]:
      {
        color: infoColor[0],
      },
    [`&.${CampaignStatusView.Draft} svg, &.${LineitemViewStatus.Archived} svg`]:
      {
        color: grayColor[0],
      },
    [`&.${CampaignStatusView.Running} svg, &.${LineitemStatus.Running} svg`]: {
      color: successColor[0],
    },
    [`&.${CampaignStatusView.Paused} svg, &.${LineitemStatus.Paused} svg`]: {
      color: dangerColor[0],
    },
    [`&.${LineitemStatus.AutoPaused} svg`]: {
      color: warningColor[0],
    },
  },
  statusIcon: {
    height: "10px !important",
    width: "10px !important",
    marginRight: 4,
  },
  ellipsis: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
});

type IProps = {
  status?: LineitemStatus | CampaignStatusView | LineitemViewStatus;
  statusLabel?: string | React.ReactNode;
  statusTooltip?: string;
  className?: string;
  width?: string;
  height?: string;
  tooltipOnlyOnBadge?: boolean;
};

function LineitemStatusBadge({
  status,
  statusTooltip,
  statusLabel,
  className,
  width,
  height,
  tooltipOnlyOnBadge,
}: IProps) {
  const { classes, cx } = useStyles();

  if (!status) {
    return null;
  }

  return (
    <Typography
      className={cx(classes.status, classes.ellipsis, status, className)}
      style={{ width, height }}
      variant="body2">
      {tooltipOnlyOnBadge ? (
        <>
          <Tooltip
            arrow
            title={statusTooltip}
            placement="top">
            <SvgIcon className={cx(classes.statusIcon, "statusIcon")}>
              <circle
                cx="12"
                cy="12"
                r="12"
              />
            </SvgIcon>
          </Tooltip>

          <span data-qa="status">{statusLabel ?? status}</span>
        </>
      ) : (
        <Tooltip
          arrow
          title={statusTooltip}
          placement="top">
          <SvgIcon className={cx(classes.statusIcon, "statusIcon")}>
            <circle
              cx="12"
              cy="12"
              r="12"
            />
          </SvgIcon>
          <span data-qa="status">{statusLabel ?? status}</span>
        </Tooltip>
      )}
    </Typography>
  );
}

export default LineitemStatusBadge;
